var map = {
	"./bmcg-int-pp-logo.svg": 4348,
	"./bmcg-int-pp.svg": 4045,
	"./bmcg-ipkp-logo.svg": 454,
	"./bmcg-ipkp.svg": 7143,
	"./carg-pp-logo.svg": 4469,
	"./carg-pp.svg": 8116,
	"./cp-bal-logo.svg": 1357,
	"./cp-bal.svg": 7235,
	"./default-logo.svg": 7989,
	"./default.svg": 2701,
	"./empty-logo.svg": 7078,
	"./fan-box-logo.svg": 8218,
	"./fan-box.svg": 7670,
	"./fan-pp-logo.svg": 2261,
	"./fan-pp.svg": 4650,
	"./flag-bg.svg": 5875,
	"./flag-cz.svg": 6996,
	"./flag-ee.svg": 3232,
	"./flag-et.svg": 8312,
	"./flag-gb.svg": 5302,
	"./flag-gr.svg": 679,
	"./flag-hu.svg": 314,
	"./flag-lt.svg": 5846,
	"./flag-lv.svg": 4201,
	"./flag-pl.svg": 4249,
	"./flag-ro.svg": 5957,
	"./flag-sk.svg": 3822,
	"./gls-ps-logo.svg": 2986,
	"./gls-ps.svg": 9572,
	"./hup-cs-logo.svg": 5114,
	"./hup-cs.svg": 5488,
	"./hup-pm-logo.svg": 3793,
	"./hup-pm.svg": 2972,
	"./hup-pp-logo.svg": 3611,
	"./hup-pp.svg": 4418,
	"./index.html": 2640,
	"./loader.gif": 2162,
	"./olza-logo.png": 5083,
	"./omni-pm-logo.svg": 8432,
	"./omni-pm.svg": 2501,
	"./payment-card.svg": 3522,
	"./payment-cash.svg": 9560,
	"./payment-online.svg": 1199,
	"./payment-unknown.svg": 6525,
	"./pin.svg": 6867,
	"./polp-pp-logo.svg": 348,
	"./polp-pp.svg": 2078,
	"./ppl-ps-logo.svg": 7365,
	"./ppl-ps.svg": 2916,
	"./saeb-box-logo.svg": 9224,
	"./saeb-box.svg": 4788,
	"./service-cod.svg": 3469,
	"./service-open247.svg": 4295,
	"./service-unknown.svg": 6436,
	"./sp-box-logo.svg": 9959,
	"./sp-box.svg": 2129,
	"./sps-ps-logo.svg": 9877,
	"./sps-ps.svg": 4884,
	"./venip-pp-logo.svg": 3372,
	"./venip-pp.svg": 8430,
	"./wedo-box-logo.svg": 4350,
	"./wedo-box.svg": 9888,
	"./zas-acs-pp-logo.svg": 9333,
	"./zas-acs-pp.svg": 5028,
	"./zas-col-logo.svg": 4290,
	"./zas-col.svg": 4294,
	"./zas-econt-box-logo.svg": 758,
	"./zas-econt-box.svg": 3471,
	"./zas-econt-pp-logo.svg": 2734,
	"./zas-econt-pp.svg": 674,
	"./zas-logo.svg": 2721,
	"./zas-saeb-logo.svg": 6906,
	"./zas-saeb.svg": 7063,
	"./zas-speedy-pp-logo.svg": 3014,
	"./zas-speedy-pp.svg": 9449,
	"./zas.svg": 616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5130;